export const Friendship = [
    {
        id: "friend",
        korean: "친구",
        english: "Friend",
        romanization: "chin-gu",
    },
    {
        id: "best_friend",
        korean: "절친",
        english: "Best friend",
        romanization: "jeol-chin",
    },
    {
        id: "companion",
        korean: "동반자",
        english: "Companion",
        romanization: "dong-ban-ja",
    },
    {
        id: "buddy",
        korean: "친한 친구",
        english: "Buddy / Close friend",
        romanization: "chin-han chin-gu",
    },
    {
        id: "colleague_friend",
        korean: "직장 동료",
        english: "Colleague (friendship context)",
        romanization: "jik-jang dong-ryo",
    },
];



export const RomanticRelationships = [
    {
        id: "partner",
        korean: "파트너",
        english: "Partner",
        romanization: "pa-teu-neo",
    },
    {
        id: "fiance_male",
        korean: "약혼자 (남성)",
        english: "Fiancé",
        romanization: "yak-hon-ja (nam-seong)",
    },
    {
        id: "fiancee_female",
        korean: "약혼자 (여성)",
        english: "Fiancée",
        romanization: "yak-hon-ja (yeo-seong)",
    }
];

export const SocialRelations = [
    {
        id: "neighbor",
        korean: "이웃",
        english: "Neighbor",
        romanization: "i-ut",
    },
    {
        id: "classmate",
        korean: "급우",
        english: "Classmate",
        romanization: "geup-u",
    },
    {
        id: "colleague",
        korean: "동료",
        english: "Colleague",
        romanization: "dong-ryo",
    },
    {
        id: "acquaintance",
        korean: "아는 사람",
        english: "Acquaintance",
        romanization: "a-neun sa-ram",
    },
    {
        id: "mentor",
        korean: "멘토",
        english: "Mentor",
        romanization: "men-to",
    },
];


export const FormalRelations = [
    {
        id: "teacher",
        korean: "선생님",
        english: "Teacher",
        romanization: "seon-saeng-nim",
    },
    {
        id: "boss",
        korean: "상사",
        english: "Boss / Superior",
        romanization: "sang-sa",
    },
    {
        id: "senior",
        korean: "선배",
        english: "Senior (mentor / upperclassman)",
        romanization: "seon-bae",
    },
    {
        id: "junior",
        korean: "후배",
        english: "Junior (mentee / underclassman)",
        romanization: "hu-bae",
    },
    {
        id: "client",
        korean: "고객",
        english: "Client / Customer",
        romanization: "go-gaek",
    },
    {
        id: "manager",
        korean: "관리자",
        english: "Manager",
        romanization: "gwan-ri-ja",
    },
];

